import { z } from "zod";

export const sizeChartItemSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const sizeChartObjectSchema = z.object({
  sizechart_france: sizeChartItemSchema.array().optional(),
  sizechart_italy: sizeChartItemSchema.array().optional(),
  sizechart_uk: sizeChartItemSchema.array().optional(),
  sizechart_us: sizeChartItemSchema.array().optional(),
  sizechart_aus: sizeChartItemSchema.array().optional(),
  sizechart_eu: sizeChartItemSchema.array().optional(),
});

type SizeChartObject = z.infer<typeof sizeChartObjectSchema>;

export const getSizeChartByCountryCode = (countryCode: string) => {
  const countryCodeSizeNameFieldMap: Record<string, keyof SizeChartObject> = {
    FR: "sizechart_france",
    ES: "sizechart_france",
    PT: "sizechart_france",
    IT: "sizechart_italy",
    GB: "sizechart_uk",
    US: "sizechart_us",
    AU: "sizechart_aus",
    NZ: "sizechart_aus",
    CA: "sizechart_us",
    IE: "sizechart_uk",
  };

  const activeSizeChart = countryCodeSizeNameFieldMap[countryCode];

  if (!activeSizeChart) {
    return "sizechart_eu";
  }

  return activeSizeChart;
};
